import React from "react";
import { RouterProvider } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from "react-toastify";
import { toast_config } from "./utils/Tostify";
import routers from "./routers";
import CheckoutPage from "./Components/CheckOut/checkOut";

function App() {
  return (
    <React.Fragment>
      <RouterProvider router={routers} />
      <ToastContainer {...toast_config} />
    </React.Fragment>
    // <CheckoutPage/>
  );
}

export default App;
